import { useRouteMatch } from 'react-router-dom';
import { CountBadge } from 'assets/js/pages/contacts/data-hygiene/CountBadge';
import { DataHygieneRoutes } from 'assets/js/pages/contacts/data-hygiene/DataHygieneRoutes';
import * as NavMenu from 'components/nav-menu';
import { useDataHygieneMetrics } from 'customHooks/useDataHygieneMetrics';

const DataHygieneNavigation = () => {
    const match = useRouteMatch();

    const { data: metrics } = useDataHygieneMetrics();

    return (
        <NavMenu.Root orientation="vertical" aria-label="Data hygiene">
            <NavMenu.Item exact={true} to={match.url} className="group">
                <span className="flex items-center justify-start gap-1.5">
                    <span>Duplicates</span>
                    <CountBadge
                        size="sm"
                        count={metrics.data_hygiene.duplicates.total}
                        className={'group-[.active]:bg-blue-50 group-[.active]:text-blue-700'}
                    />
                </span>
            </NavMenu.Item>
            <NavMenu.Item to={`${match.url}/${DataHygieneRoutes.Emails}`} className="group">
                <span className="flex items-center justify-start gap-1.5">
                    <span>Emails</span>
                    <CountBadge
                        size="sm"
                        count={metrics.data_hygiene.emails.total}
                        className={'group-[.active]:bg-blue-50 group-[.active]:text-blue-700'}
                    />
                </span>
            </NavMenu.Item>
            <NavMenu.Item to={`${match.url}/${DataHygieneRoutes.PhoneNumbers}`} className="group">
                <span className="flex items-center justify-start gap-1.5">
                    <span>Phone numbers</span>
                    <CountBadge
                        size="sm"
                        count={metrics.data_hygiene.phone_numbers.total}
                        className={'group-[.active]:bg-blue-50 group-[.active]:text-blue-700'}
                    />
                </span>
            </NavMenu.Item>
            <NavMenu.Item to={`${match.url}/${DataHygieneRoutes.Addresses}`} className="group">
                <span className="flex items-center justify-start gap-1.5">
                    <span>Addresses</span>
                    <CountBadge
                        size="sm"
                        count={metrics.data_hygiene.addresses.total}
                        className={'group-[.active]:bg-blue-50 group-[.active]:text-blue-700'}
                    />
                </span>
            </NavMenu.Item>
        </NavMenu.Root>
    );
};

export { DataHygieneNavigation };
